import React from "react";

// Logo oficial do HemathClin: escudo em gradiente azul com um pulso de
// ECG (batimento) atravessando o centro, formando uma cruz médica sutil
// nos picos do traçado — não existe nenhum arquivo de logo oficial do
// HemathClin no código-fonte original (produto é white-label, cada
// clínica sobe o próprio logo), então este é criado do zero pra Henrimack.
function HemathClinLogo({ size = 32, showWordmark = false, className = "" }) {
  const gid = "hc-" + size;

  return (
    <div className={`hemathclin-logo ${className}`} style={{ display: "flex", alignItems: "center", gap: size * 0.32, justifyContent: "center" }}>
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#6fb3ff" />
            <stop offset="0.5" stopColor="#4a9eff" />
            <stop offset="1" stopColor="#2f6fd6" />
          </linearGradient>
        </defs>
        <path
          d="M50 5 L88 19 V47 C88 72 72 89 50 96 C28 89 12 72 12 47 V19 Z"
          fill="rgba(74,158,255,0.10)"
          stroke={`url(#${gid})`}
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <path
          d="M18 56 H35 L42 40 L52 68 L59 50 L64 56 H82"
          stroke={`url(#${gid})`}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="18" cy="56" r="3.2" fill={`url(#${gid})`} />
        <circle cx="82" cy="56" r="3.2" fill={`url(#${gid})`} />
      </svg>
      {showWordmark && (
        <span
          style={{
            fontFamily: 'Georgia, "Times New Roman", serif',
            fontSize: size * 0.5,
            letterSpacing: "0.08em",
            color: "#4a9eff",
            lineHeight: 1,
          }}
        >
          HEMATHCLIN
        </span>
      )}
    </div>
  );
}

export default HemathClinLogo;
